// extracted by mini-css-extract-plugin
export default {"toast":"IDWhAkoI2aoGim1vrKc9"};